'use client';

function getStaticClassNames(_ref) {
  var themeName = _ref.themeName,
      classNamesPrefix = _ref.classNamesPrefix,
      selector = _ref.selector,
      withStaticClass = _ref.withStaticClass;

  if (withStaticClass === false) {
    return [];
  }

  return themeName.map(function (n) {
    return "".concat(classNamesPrefix, "-").concat(n, "-").concat(selector);
  });
}

export { getStaticClassNames };